import { render, staticRenderFns } from "./create-provider-campaign-modal.vue?vue&type=template&id=23469cc2"
import script from "./create-provider-campaign-modal.vue?vue&type=script&lang=js"
export * from "./create-provider-campaign-modal.vue?vue&type=script&lang=js"
import style0 from "./create-provider-campaign-modal.vue?vue&type=style&index=0&id=23469cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports